import { theme, useResponsive } from "@product/scmp-sdk";
import type { FunctionComponent, ReactElement, ReactNode } from "react";
import { Children, cloneElement, isValidElement } from "react";

import { SpeechSkipClassName } from "~/components/article/article-speech/consts";

export type Props = {
  breakpointString?: string;
  children?: ReactNode;
};

export const ArticleSpeechSkipContainer: FunctionComponent<Props> = ({
  breakpointString = theme.breakpoints.up("mobile"),
  children,
}) => {
  const isInBreakpoint = useResponsive(breakpointString);
  if (!children) return null;

  return (
    <>
      {Children.map(children, child => {
        if (isValidElement(child)) {
          return cloneElement(child as ReactElement<{ className: string }>, {
            className: isInBreakpoint ? SpeechSkipClassName : "",
          });
        }
        return child;
      })}
    </>
  );
};

ArticleSpeechSkipContainer.displayName = "ArticleSpeechSkipContainer";
